(function ($) {

    const KEY_UP = 38;
    const KEY_DOWN = 40;
    const KEY_LEFT = 37;
    const KEY_RIGHT = 39;
    const KEY_TAB = 9;
    const KEY_ENTER = 13;
    const KEY_SPACE = 32;
    const KEY_ESCAPE = 27;

    // Reset both the desktop and the mobile menu
    function resetLocationsHeaderMenu(){
        $(".primary-header-menu .main-menu-item.multi-column .menu-link")
            .removeClass( "uk-open" )
            .removeClass( "clicked" )
            .attr('aria-expanded',false);
        $(".desktop-locations-menu-container .locations-navbar").removeClass( "uk-active" );
    }

    document.addEventListener('click', function( event ) {
        let element = $(".desktop-locations-menu-container .locations-navbar");
        let container = element[0];

        if ( 
            $(event.target).closest(".multi-column").length === 0 && 
            event.target !== container && 
            !container.contains(event.target) && 
            element.hasClass("uk-active")
            ) {
                // The multi-column has not be clicked and
                // The locations-navbar has not be clicked and
                // The locations-navbar does not have a an element that has been clicked
                // The locations-navbar is not active
                resetLocationsHeaderMenu();
            }
    });

    /* document.addEventListener('keydown', function( e ) {
        if( e.key === "Escape" && $(".desktop-locations-menu-container .locations-navbar").hasClass("uk-active") ) {
            // Escape key was pressed so move the focus on the top menu item
            e.preventDefault();
            resetLocationsHeaderMenu();
            $(".primary-header-menu .main-menu-item.multi-column .menu-link").focus();
        }
    }); */

    // Locations menu link
    $(".primary-header-menu .main-menu-item.multi-column .menu-link")
        .on('mouseenter', function() {
            if( $(this).attr('aria-expanded') !== false ) {
                $(this).attr('aria-expanded',true);
            }
            if( !$(".desktop-locations-menu-container .locations-navbar").hasClass("uk-active") ) {
                $(".desktop-locations-menu-container .locations-navbar").addClass( "uk-active" );
            }
        })
        .on('click focus', function() {
            $(this).toggleClass("clicked");
            if( $(this).attr('aria-expanded') !== false ) {
                // Set the menu item as expanded
                $(this).attr('aria-expanded',true);
            }
            if( !$(".desktop-locations-menu-container .locations-navbar").hasClass("uk-active") ) {
                // Activate the desktop location menu
                $(".desktop-locations-menu-container .locations-navbar").addClass( "uk-active" );
            }
            // Show the mobile locations menu
            $(".mobile-navbar-container .mobile-menu .mobile-locations-menu-container").toggleClass( "uk-open" );
            $(".mobile-navbar-container .mobile-menu .main-mobile-menu").toggleClass( "uk-hidden" );
        })
        .on('keydown', function(e) {
            if( e.which === KEY_DOWN || e.which === KEY_ENTER || e.which === KEY_SPACE ) {
                // Down Key was pressed so Focus on the first province
                e.preventDefault();
                $(".desktop-locations-menu-container .locations-navbar .locations-header-menu .provinces-menu .provinces-list >:first-child a").focus();
            }
        });

    $(".header-container").on('mouseleave', function() {
        if( !$(".primary-header-menu .main-menu-item.multi-column .menu-link").hasClass("clicked") ) {
            // The locations menu has not been clicked so safely hide it
            resetLocationsHeaderMenu();
        }
    });

    // Mobile back button in the locations menu
    $(".back-link-container .back-link").on("click", function() {
        $(".mobile-navbar-container .mobile-menu .main-mobile-menu").toggleClass( "uk-hidden" );
        $(".mobile-navbar-container .mobile-menu .mobile-locations-menu-container").toggleClass( "uk-open" );
        $(".primary-header-menu .main-menu-item.multi-column .menu-link").removeClass( "uk-open" );
    });

    
    $(".nav-primary .primary-header-menu .main-menu-item")
        .on("click mouseenter focusin", function(e) {
            // Hide the locations menu and reset multi-column if user clicks any other menu item
            if ( !$(this).hasClass( "multi-column") ) {
                resetLocationsHeaderMenu();
            }
        })
        .on('keydown', function(e) {
            if( $(this).hasClass('menu-item-has-children') && ( e.which === KEY_ENTER || e.which === KEY_SPACE ) ) {
                // This is a parent item so focus on the first menu item
                $(this).find(".uk-navbar-dropdown > ul > li:first-child > a").focus();
            }
        });
  
    // When a province is picked from the locations menu
    $(".locations-header-menu .provinces-menu .parent-menu-item")
        .on("click mouseenter focusin", function() {
            var currentMenuItem = this;
            var menuItemId = $(this).attr('custom-filter');

            // Make sure that none of the items are active
            $(".locations-header-menu .provinces-menu .parent-menu-item").each( function() {
                if ( $(this).hasClass( "uk-active") ) {
                    $(this).removeClass( "uk-active" );
                }
            });

            if ( !$(currentMenuItem).hasClass( "uk-active") ) {
                // The current item was not active so activate it
                $(currentMenuItem).toggleClass( "uk-active" );

                $(".locations-menu .location-content").each( function() {
                    if ( $(this).hasClass( menuItemId ) ) {
                        // An element with desired class has been found so activate it
                        $(this).addClass( "toggle-item" );
                        // Set the focus on the first location
                    } else {
                        $(this).removeClass( "toggle-item" );
                    }
                });
            }
        })
        .on('keydown', function(e) {
            if( e.which === KEY_RIGHT || e.which === KEY_ENTER || e.which === KEY_SPACE ) {
                // Right key has been pressed
                e.preventDefault();
                $(".locations-menu .location-content").each( function() {
                    if ( $(this).hasClass( "toggle-item" ) ) {
                        $(this).find(".sub-menu-content:first-child >:first-child a").focus();
                    }
                });
            } else if( e.which === KEY_UP ) {
                // Up Key was pressed
                e.preventDefault();
                if( $(this).parent().prev().length ) {
                    $(this).parent().prev().find("> a").focus();
                } else {
                    $(this).parent().parent().find(">:last-child a").focus();
                }
            } else if( e.which === KEY_DOWN ) {
                // Down key was pressed
                e.preventDefault();
                if( $(this).parent().next().length ) {
                    $(this).parent().next().find("> a").focus();
                } else {
                    $(this).parent().parent().find(">:first-child a").focus();
                }
            } else if( e.which === KEY_TAB ) {
                // Tab Key was pressed
                if( $(this).parent().is(':last-child') ) {
                    // Last province has been reached so return back to the main header menu
                    e.preventDefault();
                    $(".primary-header-menu .main-menu-item.multi-column").next().find("> a").focus();
                } else if( $(this).parent().is(':first-child') && e.shiftKey ) {
                    // First province has been reached so return back to the main header menu
                    e.preventDefault();
                    $(".primary-header-menu .main-menu-item.multi-column").prev().find("> a").focus();
                }
            } else if( e.which === KEY_ESCAPE ) {
                e.preventDefault();
                resetLocationsHeaderMenu();
                $(".primary-header-menu .main-menu-item.multi-column .menu-link").focus();
            }
        });

    // Links in the location menu
    $(".locations-menu .location-content .sub-menu-content .sub-menu-item .sub-menu-link").on('keydown', function(e) {
        if( e.which === KEY_UP ) {
            // Up Key was pressed
            e.preventDefault();
            if( $(this).parent().prev().length ) {
                // Previous location exists so focus on it
                $(this).parent().prev().find(".sub-menu-link").focus();
            } else {
                // No previous items found so go to the previous column
                let previousColumn = $(this).parent().parent().prev().find(">:last-child a");
                if( previousColumn.length ) {
                    previousColumn.focus();
                } else {
                    // No previous columns left so go to the last item in the last column
                    $(this).parent().parent().parent().find(">:last-child > :last-child a").focus();
                }
            }
        }
        else if( e.which === KEY_DOWN ) {
            // Down Key was pressed
            e.preventDefault();
            if( $(this).parent().next().length ) {
                // Next location exists so focus on it
                $(this).parent().next().find(".sub-menu-link").focus();
            } else {
                let nextColumn = $(this).parent().parent().next().find(">:first-child a");
                if( nextColumn.length ) {
                    nextColumn.focus();
                } else {
                    // No next columns found so go to the first item in the first column
                    $(this).parent().parent().parent().find(">:first-child > :first-child > a").focus();
                }
            }
        }
        else if( e.which === KEY_LEFT ) {
            // Left Key was pressed
            e.preventDefault();
            if( $(this).parent().parent().is(':first-child') ) {
                // We are in the first location row so move back to the current province
                $(".desktop-locations-menu-container .locations-navbar .locations-header-menu .provinces-menu .provinces-list .province").find("a.uk-active").parent().find("a").focus();
            }
        } 
        else if( e.which === KEY_TAB ) {
            // Tab Key was pressed
            if( $(this).parent().parent().next().find(">:first-child a").length === 0 && $(this).parent().next().length === 0 ) {
                // There is no next column and no next location
                e.preventDefault();
                // Find the next province after the currently active one
                let nextProvince = $(".desktop-locations-menu-container .locations-navbar .locations-header-menu .provinces-menu .provinces-list .province").find("a.uk-active").parent().next();
                if( nextProvince.length ) {
                    // There is a next province so go to it
                    nextProvince.find("a").focus();
                } else {
                    // Go to the first province
                    $(".desktop-locations-menu-container .locations-navbar .locations-header-menu .provinces-menu .provinces-list >:first-child a").focus();
                }
            }
        }
        else if( e.which === KEY_ESCAPE ) {
            e.preventDefault();
            // Escape was pressed so return to the parent province
            $(".desktop-locations-menu-container .locations-navbar .locations-header-menu .provinces-menu .provinces-list .province").find("a.uk-active").parent().find("a").focus();
        }
    });
})(jQuery);